const PGAdapter = require('../../common/pg-adapter')

const LOCATION_OPTIONS_TABLE_NAME = 'avocado.data_location_options'
const LOCATION_OPTIONS_COLUMNS = [
  'location_id',
  'has_pcr',
  'facility_id',
  'ward',
  'tracks_partner_balances',
  'warehouse_code',
  'supplies_cold_chain',
  'alias',
  'batch_tracking_services',
  'created_at',
  'updated_at'
]

class LocationOptionsPgAdapter extends PGAdapter {
  constructor ({pgConnection, logger, username}) {
    super(pgConnection,
      LOCATION_OPTIONS_TABLE_NAME,
      username,
      LOCATION_OPTIONS_COLUMNS,
      'location_id',
      {},
      logger
    )
  }

  async upsert (uuid, doc) {
    const toBooleanOrNull = (value) => {
      if (value === null || value === undefined || value === '') {
        return null
      }
      return Boolean(value)
    }

    const locationOptions = {
      location_id: uuid,
      has_pcr: toBooleanOrNull(doc.additionalData && doc.additionalData.hasPcr),
      facility_id: (doc.additionalData && doc.additionalData.facilityId) || null,
      ward: (doc.additionalData && doc.additionalData.ward) || null,
      tracks_partner_balances: toBooleanOrNull(doc.additionalData && doc.additionalData.tracksPartnerBalances),
      warehouse_code: (doc.additionalData && doc.additionalData.warehouseCode) || null,
      supplies_cold_chain: toBooleanOrNull(doc.additionalData && doc.additionalData.suppliesColdChain),
      alias: doc.alias,
      batch_tracking_services: doc.batchTrackingServices,
      created_at: doc.createdAt,
      updated_at: new Date()
    }
    return super.upsert(locationOptions)
  }

  async getLocationsByWarehouseCodes (warehouseCodes) {
    if (!warehouseCodes || warehouseCodes.length === 0) return []

    const sql = `
      SELECT lo.warehouse_code, lo.location_id, l.fsid
      FROM avocado.data_location_options lo
      JOIN avocado.data_location l ON l.uuid = lo.location_id
      WHERE lo.warehouse_code = ANY($1)`

    const { rows } = await this.pgConnection.query(sql, [warehouseCodes])
    return rows
  }
}

module.exports = LocationOptionsPgAdapter
